import React from 'react';
import { CouponCard } from './CouponCard';
import { ShoppingCartIcon, MonitorIcon, CarIcon, PlayIcon } from 'lucide-react';
export const CouponList = ({
  onCopyCode,
  onShowHowTo,
  activeCategory,
  activeFilter
}) => {
  const coupons = [{
    id: 1,
    brand: 'Rimi',
    logo: <ShoppingCartIcon size={20} data-id="element-46" />,
    description: '15% off groceries',
    code: 'SAVE15',
    expires: '2023-12-31',
    status: 'active'
  }, {
    id: 2,
    brand: 'Apple',
    logo: <MonitorIcon size={20} data-id="element-47" />,
    description: '10% off accessories',
    code: 'APPLE10',
    expires: '2024-01-15',
    status: 'active'
  }, {
    id: 3,
    brand: 'Bolt',
    logo: <CarIcon size={20} data-id="element-48" />,
    description: 'Free ride up to €10',
    code: 'BOLTFREE',
    expires: '2023-11-11',
    status: 'expiring'
  }, {
    id: 4,
    brand: 'Netflix',
    logo: <PlayIcon size={20} data-id="element-49" />,
    description: '30 days free trial',
    code: 'NETFLIX30',
    expires: '2023-12-25',
    status: 'expired'
  }];
  // Filter coupons based on active category and filter
  const filteredCoupons = coupons.filter(coupon => activeCategory === 'all' || coupon.category === activeCategory).sort((a, b) => {
    if (activeFilter === 'expiring') {
      return new Date(a.expires) - new Date(b.expires);
    }
    // Other sorting logic would go here
    return 0;
  });
  if (filteredCoupons.length === 0) {
    return <div className="py-12 text-center" data-id="element-50">
        <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-51">
          <FilterIcon size={24} className="text-gray-400" data-id="element-52" />
        </div>
        <h3 className="text-lg font-medium mb-1" data-id="element-53">No coupons found</h3>
        <p className="text-gray-500" data-id="element-54">Try clearing your filters</p>
        <button className="mt-4 text-blue-600 font-medium" data-id="element-55">
          Clear filters
        </button>
      </div>;
  }
  return <section className="mb-8" data-id="element-56">
      <div className="space-y-4" data-id="element-57">
        {coupons.map(coupon => <CouponCard key={coupon.id} coupon={coupon} onCopyCode={() => onCopyCode(coupon)} onShowHowTo={() => onShowHowTo(coupon)} data-id="element-58" />)}
      </div>
    </section>;
};